import {useQueryParamValue} from '@hconnect/common/hooks'

import {LOCATION_STATUS_DEFAULT_TIME_RANGE, KEY_TIME_RANGE} from '../consts'

export const useLocationStatusPageParams = () => {
  const [timeRangeParam, setTimeRangeParam] = useTimeRangeParam()

  return {
    timeRangeParam,
    setTimeRangeParam
  }
}

const useTimeRangeParam = (): [string, (value: string) => void] => {
  const [timeRange, setTimeRange] = useQueryParamValue<string>(KEY_TIME_RANGE, {
    keepInLocalStorage: true
  })

  return [timeRange || LOCATION_STATUS_DEFAULT_TIME_RANGE, setTimeRange]
}
